import React, { useState } from "react";
import axios from "axios";
import styles from "./css/MyAccount.module.css";
import { TextField } from "@mui/material";
import { useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Password = () => {
  const language = useSelector((state: any) => state.language.value);
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const accessToken = localStorage.getItem("accessToken");

  const notify = (message: string, isError: boolean = false) => {
    toast(message, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      theme: "light",
      type: isError ? "error" : "success",
    });
  };

  const getErrorMessage = (errorKey: string) => {
    const errorMessages = {
      "Incorrect current password": {
        RO: "Parola curentă este incorectă",
        EN: "Incorrect current password",
      },
      "Passwords do not match": {
        RO: "Parolele nu coincid",
        EN: "Passwords do not match",
      },
      "Please fill in all fields": {
        RO: "Vă rugăm să completați toate câmpurile",
        EN: "Please fill in all fields",
      },
    };

    return (
      errorMessages[errorKey]?.[language === "RO" ? "RO" : "EN"] || errorKey
    );
  };

  const handleUpdatePassword = async () => {
    setError("");
    setSuccess("");

    if (!currentPassword || !newPassword || !confirmPassword) {
      const errorMsg = getErrorMessage("Please fill in all fields");
      setError(errorMsg);
      notify(errorMsg, true);
      return;
    }

    if (newPassword !== confirmPassword) {
      const errorMsg = getErrorMessage("Passwords do not match");
      setError(errorMsg);
      notify(errorMsg, true);
      return;
    }

    try {
      const response = await axios.put(
        `${process.env.REACT_APP_SERVER_URL}/auth/update-password`,
        { currentPassword, newPassword },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      const successMsg =
        language === "RO"
          ? "Parola a fost actualizată cu succes!"
          : "Password updated successfully!";

      setSuccess(successMsg);
      notify(successMsg, false);

      setCurrentPassword("");
      setNewPassword("");
      setConfirmPassword("");
      setError("");
    } catch (error: any) {
      setSuccess("");
      console.error("Error updating password:", error);
      const backendMessage = error.response?.data?.message;
      const translatedError = getErrorMessage(backendMessage);
      setError(translatedError);
      notify(translatedError, true);
    }
  };

  return (
    <div className={styles.productContainer}>
      <span className={styles.productTitle}>
        {language === "RO" ? "Securitate" : "Security"}
      </span>
      <div className={styles.productInfo}>
        <div className={styles.frame}>
          <span className={styles.productTitle7}>
            {language === "RO" ? "Parola" : "Password"}
          </span>
          <div className={styles.form}>
            <div className={styles.inputs}>
              <div className={styles.inputField}>
                <TextField
                  sx={{
                    width: "100%",
                    height: "inherit",
                    "& .MuiFilledInput-root": { height: "inherit" },
                  }}
                  type="password"
                  value={currentPassword}
                  onChange={(e) => setCurrentPassword(e.target.value)}
                  placeholder={
                    language === "RO" ? "Parola curentă" : "Current password"
                  }
                  variant="filled"
                  error={!!error}
                />
              </div>
            </div>
            <div className={styles.inputField9}>
              <div className={styles.inputField}>
                <TextField
                  sx={{
                    width: "100%",
                    height: "inherit",
                    "& .MuiFilledInput-root": { height: "inherit" },
                  }}
                  type="password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  placeholder={
                    language === "RO" ? "Parola nouă" : "New password"
                  }
                  variant="filled"
                  error={!!error}
                />
              </div>
            </div>
            <div className={styles.inputField9}>
              <div className={styles.inputField}>
                <TextField
                  sx={{
                    width: "100%",
                    height: "inherit",
                    "& .MuiFilledInput-root": { height: "inherit" },
                  }}
                  type="password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  placeholder={
                    language === "RO"
                      ? "Confirmă parola nouă"
                      : "Confirm new password"
                  }
                  variant="filled"
                  error={!!error}
                />
              </div>
            </div>
          </div>
          {error && (
            <div style={{ color: "red", marginTop: "10px", fontSize: "14px" }}>
              {error}
            </div>
          )}
          {success && (
            <div
              style={{ color: "green", marginTop: "10px", fontSize: "14px" }}
            >
              {success}
            </div>
          )}
          <span className={styles.lostPassword}>
            {language === "RO" ? "Ai uitat parola?" : "Forgot password?"}
          </span>
          <button className={styles.buttonE} onClick={handleUpdatePassword}>
            <span className={styles.addToCartF}>
              {language === "RO" ? "Actualizează" : "Update"}
            </span>
          </button>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default Password;
